import React from 'react'

import {
  BrowserNotifications,
  FollowedProjects,
  NotificationsTags,
  NotificationsZones,
  ProductMatchNotifications
} from 'modulesCommon/Notifications/containers'
import { Layout } from 'components'

const NotificationsPage = () => (
  <Layout>
    <NotificationsTags />
    <NotificationsZones />
    <FollowedProjects />
    <BrowserNotifications />
    <ProductMatchNotifications />
  </Layout>
)

export default NotificationsPage
